import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Shadow from "components/Shadow";
import ImgIcon from "components/imgIcon";
import Separator from "components/Separator";

import { colors, sizes } from "assets/constants";
import tinycolor from "tinycolor2";
import css from "styles";
import { alertPermission } from "utils";
import { icons } from "assets/icons";

const SecondaryItemCard: React.FC<SecondaryItemCardT> = ({
  imgIcon,
  title,
  counts,
  color,
  c,
  onPress,
  onAdd,
  disabled,
  disabledAdd,
}) => {
  return (
    <TouchableOpacity
      onPress={disabled ? alertPermission : onPress}
      style={{ ...styles.card }}
      activeOpacity={disabled ? 1 : sizes.tapOpacity}
    >
      {disabled && (
        <View
          style={{
            position: "absolute",
            top: -5,
            right: -5,
            zIndex: 1000,
          }}
        >
          <ImgIcon icon={icons._no_entry} size={22} />
        </View>
      )}

      <View style={{ flex: 1, opacity: disabled ? 0.5 : 1 }}>
        <Shadow
          shadow={{
            opacity: 1,
          }}
          style={styles.shadowCard}
        >
          <View style={css.centralElContainer}>
            <View
              style={{
                ...styles.iconContainer,
                backgroundColor: tinycolor(color).lighten(55).toString(),
              }}
            >
              <ImgIcon size={20} color={color} {...imgIcon} />
            </View>

            <Text
              weight="extraBold"
              color={tinycolor(color).darken(10).toString()}
            >
              {title}
            </Text>
          </View>
          <Separator
            size={"110%"}
            space={0}
            color={tinycolor(color).lighten(73).toString()}
          />
          <TouchableOpacity
            onPress={disabledAdd ? alertPermission : onAdd}
            activeOpacity={sizes.tapOpacity}
            style={styles.countContainer}
          >
            <View
              style={{
                left: -5,
                // borderWidth: 1,
                width: 30,
                height: 30,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: sizes.radius.md,
                backgroundColor: tinycolor(c).lighten(50).toString(),
              }}
            >
              <Icon
                type="ion"
                // name="add-circle-outline"
                name="add"
                size={23}
                color={tinycolor(c).darken(25).toString()}
              />
            </View>

            <Text
              // lang="en"
              top={2}
              color={tinycolor(c).darken(20).toString()}
              weight="black"
              size={"xxl"}
            >
              {counts}
            </Text>
          </TouchableOpacity>
        </Shadow>
      </View>
    </TouchableOpacity>
  );
};

export default SecondaryItemCard;

const styles = StyleSheet.create({
  card: { height: "100%", width: "100%" },

  shadowCard: {
    width: "100%",
    height: "100%",
    paddingHorizontal: sizes.space,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.white,
  },

  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center",
  },

  countContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: 45,
  },
});
